<template src="./component.html"></template>

<script>
export default {
  name: "Scheme"
}
</script>

<style src="./component.scss" scoped lang="scss"/>
